/**
 * BackToQueueIcon/index.js
 * desc: back to queue arrow icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const BackToQueueIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="back-to-queue icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.backToQueue.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M12.7059 19.0588V14.8235H14.8235V21.1765H0V0H14.8235V6.35294H12.7059V2.11765H2.11765V19.0588H12.7059ZM12.7059 8.47059C15.6304 8.47059 18 10.8402 18 13.7647V14.8235L17.4335 14.2571C16.4393 13.2639 15.0935 12.7059 13.6895 12.7059H10.5882V16.9412L4.23529 10.5882L10.5882 4.23529V8.47059H12.7059Z"/>
        </svg>
    </IconButton>
);


export default BackToQueueIcon;
